/* Caroline Wolf — product.js: variant selection, gallery, related products */
(function () {
  'use strict';

  if (window.customElements.get('product-page')) return;

  function formatMoney(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang === 'en' ? 'en-IL' : 'he-IL', {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  var ProductPage = function () {
    return Reflect.construct(HTMLElement, [], ProductPage);
  };
  ProductPage.prototype = Object.create(HTMLElement.prototype);
  ProductPage.prototype.constructor = ProductPage;

  ProductPage.prototype.connectedCallback = function () {
    var jsonEl = this.querySelector('[data-product-json]');
    if (!jsonEl) return;
    this.variants = JSON.parse(jsonEl.textContent);
    this.currency = this.getAttribute('data-currency') || 'ILS';
    var self = this;

    this.addEventListener('change', function (event) {
      if (event.target.matches('[data-option-value]')) self.onOptionChange();
    });

    this.addEventListener('click', function (event) {
      var thumb = event.target.closest('[data-thumb]');
      if (thumb) self.showMedia(thumb.getAttribute('data-media-id'));
    });

    if (this.querySelector('[data-option-index]')) this.markUnavailable(this.selectedOptions());
    this.watchStrip();
  };

  ProductPage.prototype.selectedOptions = function () {
    var options = [];
    this.querySelectorAll('[data-option-index]').forEach(function (group) {
      var checked = group.querySelector('input:checked');
      options[parseInt(group.getAttribute('data-option-index'), 10)] = checked ? checked.value : null;
    });
    return options;
  };

  /* Flag each value that has no purchasable variant given the other selected options. */
  ProductPage.prototype.markUnavailable = function (options) {
    var variants = this.variants;
    this.querySelectorAll('[data-option-index]').forEach(function (group) {
      var index = parseInt(group.getAttribute('data-option-index'), 10);
      group.querySelectorAll('.option-value').forEach(function (wrap) {
        var input = wrap.querySelector('input');
        if (!input) return;
        var available = variants.some(function (v) {
          if (!v.available || v.options[index] !== input.value) return false;
          return options.every(function (value, i) {
            return i === index || value === null || v.options[i] === value;
          });
        });
        if (available) wrap.removeAttribute('data-unavailable');
        else wrap.setAttribute('data-unavailable', '');
      });
    });
  };

  ProductPage.prototype.onOptionChange = function () {
    var options = this.selectedOptions();
    var variant = this.variants.find(function (v) {
      return options.every(function (value, index) {
        return value === null || v.options[index] === value;
      });
    });

    this.querySelectorAll('[data-option-index]').forEach(function (group) {
      var checked = group.querySelector('input:checked');
      var label = group.querySelector('[data-selected-value]');
      if (checked && label) label.textContent = checked.value;
    });
    this.markUnavailable(options);

    if (!variant) return;

    var idInput = this.querySelector('[data-variant-id]');
    if (idInput) idInput.value = variant.id;

    var priceWrapper = this.querySelector('[data-price-wrapper] .price');
    if (priceWrapper) {
      var html = '<span class="price__current">' + formatMoney(variant.price, this.currency) + '</span>';
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        html += ' <s class="price__compare">' + formatMoney(variant.compare_at_price, this.currency) + '</s>';
      }
      priceWrapper.innerHTML = html;
    }

    var addButton = this.querySelector('[data-add-button]');
    var addText = this.querySelector('[data-add-text]');
    if (addButton) {
      addButton.disabled = !variant.available;
      if (addText) {
        addText.textContent = variant.available
          ? addButton.getAttribute('data-text-add')
          : addButton.getAttribute('data-text-sold-out');
      }
    }

    if (variant.featured_media) this.showMedia(String(variant.featured_media.id));

    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());
  };

  ProductPage.prototype.isStrip = function () {
    return window.matchMedia('(max-width: 989px)').matches;
  };

  ProductPage.prototype.markThumb = function (mediaId) {
    this.querySelectorAll('[data-thumb]').forEach(function (thumb) {
      var current = thumb.getAttribute('data-media-id') === mediaId;
      thumb.setAttribute('aria-current', current ? 'true' : 'false');
      if (current && thumb.scrollIntoView) thumb.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    });
  };

  ProductPage.prototype.showMedia = function (mediaId) {
    var target = null;
    this.querySelectorAll('.product-gallery__main [data-media-id]').forEach(function (slide) {
      var match = slide.getAttribute('data-media-id') === mediaId;
      slide.hidden = !match;
      if (match) target = slide;
    });
    this.markThumb(mediaId);
    if (target && this.isStrip()) {
      var main = this.querySelector('[data-gallery-main]');
      if (main) main.scrollTo({ left: main.scrollLeft + (target.getBoundingClientRect().left - main.getBoundingClientRect().left), behavior: 'smooth' });
    }
  };

  /* On small screens the main area is a swipeable strip: keep the thumbnail state in sync with the scroll position. */
  ProductPage.prototype.watchStrip = function () {
    var main = this.querySelector('[data-gallery-main]');
    if (!main || !('IntersectionObserver' in window)) return;
    var self = this;
    var observer = new IntersectionObserver(function (entries) {
      if (!self.isStrip()) return;
      entries.forEach(function (entry) {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.6) self.markThumb(entry.target.getAttribute('data-media-id'));
      });
    }, { root: main, threshold: [0.6] });
    main.querySelectorAll('[data-media-id]').forEach(function (slide) { observer.observe(slide); });
  };

  window.customElements.define('product-page', ProductPage);

  /* Related products via the Product Recommendations API */
  if (!window.customElements.get('related-products')) {
    var RelatedProducts = function () {
      return Reflect.construct(HTMLElement, [], RelatedProducts);
    };
    RelatedProducts.prototype = Object.create(HTMLElement.prototype);
    RelatedProducts.prototype.constructor = RelatedProducts;
    RelatedProducts.prototype.connectedCallback = function () {
      var self = this;
      var url = this.getAttribute('data-url');
      if (!url || this.hasAttribute('data-loaded')) return;
      var observer = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        observer.disconnect();
        fetch(url)
          .then(function (res) { return res.text(); })
          .then(function (text) {
            var parsed = new DOMParser().parseFromString(text, 'text/html');
            var fresh = parsed.querySelector('related-products');
            if (fresh && fresh.innerHTML.trim() !== '') {
              self.innerHTML = fresh.innerHTML;
              self.setAttribute('data-loaded', 'true');
            }
          });
      }, { rootMargin: '200px' });
      observer.observe(this);
    };
    window.customElements.define('related-products', RelatedProducts);
  }
})();
